<template>
  <div>
    <el-form :model="queryCondition" ref="queryConditionRef" label-position="right" label-width="100px" class="searchForm">
      <el-row>
        <el-col :span="6">
          <el-form-item label="Category3" prop="category3">
            <el-select v-model="queryCondition.category3" clearable style="width:100%" placeholder="请选择">
              <el-option :key="index" v-for="(item,index) in categoryList" :label="item.object" :value="item.key"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="ASL" prop="aslName">
            <el-input v-model="queryCondition.aslName" clearable style="width:100%" placeholder="请输入"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="主Sponsor" prop="mainSponsor">
            <el-input v-model="queryCondition.mainSponsor" clearable style="width:100%" placeholder="请输入"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <div style="text-align: center;">
            <el-button size="mini" @click="search" type="primary">查询</el-button>
            <el-button size="mini" @click="reset" type="primary">重置</el-button>
          </div>
        </el-col>
      </el-row>
    </el-form>
    <div style="margin-top: 15px;margin-bottom: 10px;">
      <el-button class="btn" type="primary" @click="addAuth">新增授权</el-button>
      <el-button class="btn" type="danger" @click="batchDelete" :disabled="multipleSelection.length == 0">批量删除</el-button>
    </div>
    <ux-grid ref="plxTable" :data="tableData" @selection-change="selectionChange" max-height="500" show-overflow="tooltip" highlight-current-row>
      <ux-table-column align="center" type="checkbox" width="80" />
      <ux-table-column align="center" title="Category3" field="category3" min-width="120" />
      <ux-table-column align="center" title="ASL" field="aslName" min-width="120" />
      <ux-table-column align="center" title="主Sponsor" field="mainSupplierName" min-width="120" />
      <ux-table-column align="center" title="主Sponsor可见性" field="" min-width="130">
        <template v-slot="scope">
          <div style="display: flex;justify-content: center;flex-wrap: wrap;">
            <div style="margin: 5px;" v-for="item in scope.row.mainBreedingModes">
              <el-tag type="info">{{item | modeFilter(breedingModeOptions)}}</el-tag>
            </div>
          </div>
        </template>
      </ux-table-column>
      <ux-table-column align="center" title="授权Sponsor" field="authedSupplierName" min-width="120" />
      <ux-table-column align="center" title="授权Sponsor可见性" field="" min-width="140">
        <template v-slot="scope">
          <div style="display: flex;justify-content: center;flex-wrap: wrap;">
            <div style="margin: 5px;" v-for="item in scope.row.authedBreedingModes">
              <el-tag type="warning">{{item | modeFilter(breedingModeOptions)}}</el-tag>
            </div>
          </div>
        </template>
      </ux-table-column>
<!--      <ux-table-column align="center" title="更新人" field="" min-width="120" />-->
<!--      <ux-table-column align="center" title="更新时间" field="" min-width="120" />-->
      <ux-table-column align="center" title="操作" min-width="120" field="createDate">
        <template v-slot="scope">
          <el-button type="text" size="small" @click="edit(scope.row)">编辑</el-button>
          <el-button type="text" @click="deleteItem(scope.row)">删除</el-button>
        </template>
      </ux-table-column>
    </ux-grid>
    <div class="pagination">
      <el-pagination @size-change="pageSizeChange" @current-change="pageNumberChange" :current-page="queryCondition.pageNum" :page-sizes="pageSizeList" :page-size="queryCondition.pageSize" :layout="pageLayout" :total="totalCount">
      </el-pagination>
    </div>

    <el-dialog :title="dialogTitle" :visible.sync="display" append-to-body width="650px" :close-on-click-modal="false">
      <div v-if="display">
        <el-form :model="authForm" ref="authFormRef" label-position="right" label-width="140px" :rules="rules">
          <el-form-item required label="Category3" prop="category3">
            <el-input style="width: 100%;" v-model="authForm.category3" disabled></el-input>
          </el-form-item>
          <el-form-item required label="ASL" prop="aslName">
            <el-select style="width: 100%;" v-model="authForm.aslName" @change="selectAsl" :disabled="operation === 'edit'">
              <el-option v-for="(item,index) in aslOptions" :key="index" :label="item.aslName" :value="item.aslName"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item required label="主Sponsor" prop="mainSupplierName">
            <el-input style="width: 100%;" v-model="authForm.mainSupplierName" disabled></el-input>
          </el-form-item>
          <el-form-item label="养殖模式" prop="mainBreedingModes">
            <el-select style="width: 100%;" v-model="authForm.mainBreedingModes" multiple @change="changeMainBreedingModes">
              <el-option v-for="(item,index) in breedingModeOptions" :key="index" :label="item.object" :value="item.key"></el-option>
            </el-select>
          </el-form-item>
          <div class="item__tips">限制主Sponsor查看自己名下农场的养殖模式范围，不选择则全部可见</div>
          <el-form-item label="授权Sponsor" prop="authedSupplierName">
            <el-input v-if="authedSponsorEditable" v-model="authForm.authedSupplierName" readonly placeholder="">
              <el-button @click="viewSponsorDialog" slot="append" icon="el-icon-search"></el-button>
            </el-input>
            <el-input v-else v-model="authForm.authedSupplierName" disabled></el-input>
          </el-form-item>
          <div class="item__tips">选择后，这些Sponsor也可以管理该ASL的数据</div>
          <el-form-item label="授权养殖模式" prop="authedBreedingModes">
            <el-select style="width: 100%;" v-model="authForm.authedBreedingModes" multiple @change="changeAuthedBreedingModes">
              <el-option v-for="(item,index) in breedingModeOptions" :key="index" :label="item.object" :value="item.key"></el-option>
            </el-select>
          </el-form-item>
          <div class="item__tips">限制授权Sponsor查看主Sponsor名下农场的养殖模式范围，不选择则全部可见</div>
        </el-form>
        <el-row type="flex" justify="center" align="middle">
          <el-button size="mini" @click="cancel">取消</el-button>
          <el-button size="mini" type="primary" @click="save">保存</el-button>
        </el-row>
      </div>
    </el-dialog>

    <el-dialog title="Sponsor主数据" :visible.sync="dialogVisible" width="40%" append-to-body :close-on-click-modal="false">
      <facilityList v-if="dialogVisible" @selectData="selectData"></facilityList>
    </el-dialog>
  </div>
</template>

<script>

import aslApi from "@/api/rmcProtein/asl";
import rmcProtFarmApi from "@/api/rmcProtein/farm";
import facilityList from "@/components/page/RMC/Protein/ASL/facilityList.vue";

export default {
  components: {facilityList},
  props: ["categoryList", "breedingModeOptions"],
  data() {
    return {
      queryCondition: {
        aslName: "",
        category3: "",
        mainSponsor: "",
        pageNum: 1,
        pageSize: 15
      },
      tableData: [],
      totalCount:"",
      pageSizeList: [15, 50, 100, 1000],
      multipleSelection: [],
      dialogTitle: "新增授权配置",
      display: false,
      authForm: {
        aslName: "",
        authedBreedingModes: [],
        authedBreedingVal: "",
        authedSupplierCode: "",
        authedSupplierName: "",
        category3: "",
        mainBreedingModes: [],
        mainBreedingVal: "",
        mainSupplierCode: "",
        mainSupplierName: "",
        rmcProteinAslId: ""
      },
      aslOptions: [],
      sponsorOptions: [],
      // breedingModeOptions: [],
      authSponsorOptions: [],
      dialogVisible: false,
      operation: "",
      authedSponsorEditable: true,
      rules: {
        category3: [
          {required: true, message: " ", trigger: "change"}
        ],
        aslName: [
          {required: true, message: " ", trigger: "change"}
        ],
        mainSupplierName: [
          {required: true, message: " ", trigger: "change"}
        ],
        mainBreedingModes: [
          {required: true, message: " ", trigger: "change"}
        ],
        authedSupplierName: [
          // {required: true, message: " ", trigger: ["blur", "change"]}
        ],
        authedBreedingModes: [
          // {required: true, message: " ", trigger: "change"}
        ]
      }
    }
  },
  filters: {
    modeFilter(str, breedingModeOptions) {
      let modeObj = breedingModeOptions.find(mode => mode.key === str);
      if(modeObj) {
        return modeObj.object;
      } else {
        return str;
      }
    }
  },
  created() {
    this.getAslList();
    // this.getSelection();
    this.getTableData();
  },
  methods: {
    getAslList() {
      aslApi.getAslData({pageNum: -1,pageSize: -1}).then(res => {
        let dataList = res.resultData?res.resultData:[];
        this.aslOptions = dataList.map(item => ({
          rmcProteinAslId: item.rmcProteinAslId,
          aslGroupCode: item.aslGroupCode,
          aslGroupName: item.aslGroupName,
          aslName: item.aslName,
          category3Code: item.category3Code,
          category3Name: item.category3Name,
          sponsorCode: item.sponsorCode,
          sponsorName: item.sponsorName
        }));
      })
    },
    // getSelection() {
    //   rmcProtFarmApi.getSelection(['rmc.RmcFarmBreedingMode']).then(res => {
    //     this.breedingModeOptions = res.data['rmc.RmcFarmBreedingMode'];
    //   });
    // },
    viewSponsorDialog() {
      this.dialogVisible = true;
    },
    // 选择授权sponsor
    selectData(data){
      if(data && data.length > 0) {
        this.$set(this.authForm,'authedSupplierCode',data[0].supplierCode);
        this.$set(this.authForm,'authedSupplierName',data[0].supplierName);
      } else {
        this.$set(this.authForm,'authedSupplierCode',"");
        this.$set(this.authForm,'authedSupplierName',"");
      }
      this.dialogVisible=false
    },
    getTableData() {
      aslApi.getAslAuthConfigQuery(this.queryCondition).then(res => {
        this.tableData=res.resultData?res.resultData:[];
        this.totalCount=res.totalCount;
      })
    },
    // 查询
    search() {
      this.queryCondition.pageNum = 1;
      this.getTableData();
    },
    // 重置
    reset() {
      this.$refs.queryConditionRef.resetFields();
      this.queryCondition.pageNum = 1;
      this.queryCondition.pageSize = 15;
      this.search();
    },
    // 新增授权
    addAuth() {
      this.authForm = {
        aslName: "",
        authedBreedingModes: [],
        authedBreedingVal: "",
        authedSupplierCode: "",
        authedSupplierName: "",
        category3: "",
        mainBreedingModes: [],
        mainBreedingVal: "",
        mainSupplierCode: "",
        mainSupplierName: "",
        rmcProteinAslId: ""
      };
      this.operation = "add";
      this.authedSponsorEditable = true;
      this.dialogTitle = "新增授权配置";
      this.display = true;
    },
    // 编辑
    edit(row) {
      this.operation = "edit";
      this.authForm = row;
      this.dialogTitle = "编辑授权配置";
      let originData = JSON.parse(JSON.stringify(row));
      if(!originData.authedSupplierCode) {     // 原来授权sponsor没值则可以编辑
        this.authedSponsorEditable = true;
      } else {
        this.authedSponsorEditable = false;
      }
      this.display = true;
    },
    // 删除
    deleteItem(row) {
      this.$confirm('确认是否删除当前数据?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let request = [
          {
            authedSupplierCode: row.authedSupplierCode,
            rmcProteinAslId: row.rmcProteinAslId
          }
        ]
        aslApi.deleteAslAuthConfig(request).then(res => {
          this.$message.success("删除成功")
          this.search();
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    // 批量删除
    batchDelete() {
      this.$confirm('确认是否删除所有已勾选的数据?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let request = [];
        this.multipleSelection.forEach(select => {
          request.push({
            authedSupplierCode: select.authedSupplierCode,
            rmcProteinAslId: select.rmcProteinAslId
          })
        })
        aslApi.deleteAslAuthConfig(request).then(res => {
          this.$message.success("删除成功");
          this.search();
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    selectAsl(val) {
      // 选择ASL后带出category3和主sponsor
      let aslObj = this.aslOptions.find(asl => asl.aslName === val);
      console.log(aslObj)
      if(aslObj) {
        this.$set(this.authForm, "aslName", aslObj.aslName)
        this.$set(this.authForm, "category3", aslObj.category3Name)
        this.$set(this.authForm,'mainSupplierCode', aslObj.sponsorCode)
        this.$set(this.authForm,'mainSupplierName', aslObj.sponsorName)
        this.$set(this.authForm, "rmcProteinAslId", aslObj.rmcProteinAslId)
      }
    },
    changeMainBreedingModes(val) {
      if(val && val.length > 0) {
        this.$set(this.authForm, "mainBreedingVal", val.join(","));
      } else {
        this.$set(this.authForm, "mainBreedingVal", "");
      }
    },
    changeAuthedBreedingModes(val) {
      if(val && val.length > 0) {
        this.$set(this.authForm, "authedBreedingVal", val.join(","));
      } else {
        this.$set(this.authForm, "authedBreedingVal", "");
      }
    },
    // 保存
    save() {
      this.$refs.authFormRef.validate(valid => {
        if(valid) {
          let request = JSON.parse(JSON.stringify(this.authForm));
          if(this.operation === "add") {
            request.isNew = true;
          }
          aslApi.saveAslAuthConfig(request).then(res => {
            this.$message.success('保存成功');
            this.getTableData();
            this.display = false;
          })
        }
      })
    },
    // 取消
    cancel() {
      this.display = false;
    },
    pageSizeChange(val){
      this.queryCondition.pageSize = val
      this.getTableData()
    },
    pageNumberChange(val){
      this.queryCondition.pageNum = val
      this.getTableData()
    },
    selectionChange(val) {
      console.log(val)
      this.multipleSelection = val;
    }
  }
}
</script>

<style scoped>
.item__tips {
  margin-top: -18px;
  margin-left: 140px;
  margin-bottom: 15px;
  font-size: 12px;
  color: #999aaa;
}
</style>